import { render, staticRenderFns } from "./DirectoryHandler.vue?vue&type=template&id=8a521884"
import script from "./DirectoryHandler.vue?vue&type=script&lang=ts"
export * from "./DirectoryHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports